import { OutcomesLayoutRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/outcomes')({
  component: OutcomesLayoutRoute,
});
